<template>
  <div class="jobs-list" v-loading="loader">
    <div>
      <div style="margin-top: 12px">
        <el-checkbox @change="save" v-model="form.is_not_active">Не активен</el-checkbox>
      </div>
      <div class="jobs-ul">
        <router-link :to="`/dashboard/plan/users/${$route.params.id}`"
                     class="jobs-li"
        >
          <div class="name">
            <span style="margin-left: 10px">Компании</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link :to="`/dashboard/objects/?plan=${$route.params.id}&name=${form.name}`"
                     class="jobs-li"
        >
          <div class="name">
            <span style="margin-left: 10px">Объекты</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </router-link>

        <div class="jobs-li count" @click="resetCount" v-loading="loading">
          <span>
            Обновить счетчики
          </span>
        </div>
      </div>
    </div>
    <div class="remove-container" style="margin-top: 30px">
      <el-button style="width: 100%" type="danger" size="mini" @click="deleteObject" plain>Удалить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import work_units from '../../../data/work_units';
import {getUnits} from '../../../firestore/units';
import {getPlans} from "../../../firestore/plan";
import dayjs from "dayjs";
import axios from "axios";
import {apiUrl} from "../../../plugins/firebase";
import {getUsersOptions} from "../../../firestore/users";

export default {
  name: 'PlanIndex',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      plans: [],
      form: {},
      loading: false
    };
  },

  mounted() {

    if (this.$route.params.id) {
      this.loader = true
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('plan')
        .doc(this.$route.params.id).get().then((response) => {
        const data = response.data();
        this.form = {
          ...data,
        };
      }).finally(() => {
        this.loader = false

      });


    }
  },
  methods: {
    async resetCount() {
      this.loading = true
      let url = `onUpdateTotalValuesByReport/${this.$store.state.project.id}`

      if(this.$route.params.id) {
        url += `&queryParams=planId=${this.$route.params.id}`
      }

      try {
        await axios.get(apiUrl + '/' + url)
        this.$notify.success({
          offset: 60,
          title: 'Счетчики обновлены',
        });
      } catch (e) {
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: `Произошла ошибка повторите позже, код ошибки - ${e}`,
          type: 'error',
        })
      }

      this.loading = false
    },
    save() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('plan')
        .doc(this.$route.params.id)
        .update({
          is_not_active: this.form.is_not_active
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
      }).catch((error) => console.error(error));
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 100px);
}


.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-chevron-right {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}

.remove-container {
  display: flex;
}

.count {
  text-align: center !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Plan/Edit.vue